import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Header from "../common/components/header"
import Footer from "../common/components/footer"
import ImageCard from '../common/components/image-card'
import { getQueryString } from '../common/util'
import IndexRoute from '../common/routes/index-route'
import { Route, Redirect } from 'react-router'
import '../common/components/button.css'
import DocumentHeader from '../common/components/document-header'
import QueryString from 'query-string'



const query = QueryString.parse(QueryString.extract(window.location.href));

const referenceCode = query.referenceCode || "" ;
const utm_source = query.utm_source || "";
const utm_medium = query.utm_medium || "";
const utm_campaign = query.utm_campaign || "";
const utm_term = query.utm_term || "";
const utm_content = query.utm_content || "";
const utm_referrer = query.utm_referrer || "";

let linkSuffix =  referenceCode ? '?' : '';



if(referenceCode){
    linkSuffix += 'referenceCode=' +referenceCode.trim();
}
if(utm_source){
    linkSuffix += '&utm_source=' +utm_source;
}
if(utm_medium){
    linkSuffix += '&utm_medium=' +utm_medium;
}
if(utm_campaign){
    linkSuffix += '&utm_campaign=' +utm_campaign;
}
if(utm_term){
    linkSuffix += '&utm_term=' +utm_term;
}
if(utm_content){
    linkSuffix += '&utm_content=' +utm_content;
}
if(utm_referrer){
    linkSuffix += '&utm_referrer=' +utm_referrer;
}


console.log(referenceCode);


export default class extends React.Component{

    render(){
        const contentsIcon = require("./images/contents-icon.png");
        const landlordsIcon = require("./images/landlords-icon.png");
        const strataIcon = require("./images/strata-icon.png");
        const newLandlordsIcon = require("./images/landlord_iconcircle.png");

        return (
            <div className="app">
            <DocumentHeader icon={ require('./images/favicon.ico') }/>
            <Route exact path="/" component={ IndexRoute } />
                <Header logo={ require("./images/logo.png") } />
                <div className="content mb-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="mt-4 bt-4">What cover do you need?</h1>
                            </div>
                            <ImageCard title="CHU Landlords Insurance for Strata" imageURL={ landlordsIcon } url={ "/landlords/#/step-1" + linkSuffix }>
                                <p>CHU Landlords insurance for Strata (for properties such as apartments, units, villas and townhouses) is a tax deductible insurance that protects you against loss or damage to your investment property.
                                So you can continue to receive rent if your tenant suddenly departs or damages your property making it unfit to be occupied.
                                </p>
                                <a className="btn btn-primary mr-2" href={ "/landlords/#/step-1" + linkSuffix }><b>Get a quote</b></a>
                                <a className="btn btn-primary" href={ "/landlords/#/restore" + linkSuffix }><b>Retrieve quote</b></a>
                            </ImageCard>

                            <ImageCard title="CHU Contents Insurance for Strata" imageURL={ contentsIcon } url={ "/contents/#/step-1" + linkSuffix }>
                                <p>CHU Contents Insurance for Strata protects your personal possessions such as clothing, phones, jewellery, furniture and carpets
                                 from accidental and malicious damage, theft, water, fire and storm damage.
                                It also protects you through legal liability cover. You can choose from two levels of cover to suit your needs and budget.
                                </p>
                                <a className="btn btn-primary mr-2" href={ "/contents/#/step-1" + linkSuffix }><b>Get a quote</b></a>
                                <a className="btn btn-primary" href={ "/contents/#/restore" + linkSuffix }><b>Retrieve quote</b></a>
                            </ImageCard>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/landing-root-component.tsx